import * as React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { createBrowserHistory } from "history";
import { ThemeProvider } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";
import App from "./App";
import store from "./redux/store";
import { unregister } from "./registerServiceWorker";
import GlobalThemeProvider from "./GlobalThemeProvider";
import Main from "./Main";

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
// const store = configureStore(history);

// Augment the palette to include a custom color
// declare module '@mui/material/styles' {
//   interface Palette {
//     brandPrimary: Palette['primary'];
//     brandSecondary: Palette['primary'];
//   }

//   interface PaletteOptions {
//     brandPrimary?: PaletteOptions['primary'];
//     brandSecondary?: PaletteOptions['primary'];
//   }
// }

const theme = createTheme({
  palette: {
    primary: {
      main: "#40499D",
      light: "#525FB8",
      dark: "#1a1d3f",
    },
    brandPrimary: {
      main: "#40499D",
      light: "#525FB8",
      dark: "#1a1d3f",
      contrastText: "#fff",
      black: "#313131",
    },
    brandSecondary: {
      main: "#F8EF07",
      light: "#fbf56a",
      dark: "#7c7804",
      contrastText: "#000",
      customColor: "#FFD049",
      custombgColor: "#FFFEF0",
      custom: "#FF9500",
      yellow: "#DEAB28",
    },
    badgeBg: {
      main: "#E9E9E9",
    },
    achievementIcon: {
      newbie: "#00A3FF",
      eager: "#479D40",
      intermediate: "#FF7A00",
      boss: "#FFD14A",
      scholar: "#FF0000",
      prodigy: "#40499D",
    },
    black: {
      main: "#313131",
    },
    skeletonColor: {
      main: "#DCDEE3",
    },
    yellowColor: {
      main: "#DEAB28",
      contrastText: "#fff",
    },
    redColor: {
      main: "#FA7E77",
    },
  },
  typography: { fontFamily: ["DM Sans", "sans-serif"].join(",") },
  shadows: Array(25).fill("none"),
});

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    {/* <ThemeProvider theme={theme}> */}
    <Provider store={store}>
      {/* <ConnectedRouter history={history}> */}
      <GlobalThemeProvider>
        <Main />
      </GlobalThemeProvider>
      {/* </ConnectedRouter> */}
    </Provider>
    {/* </ThemeProvider> */}
  </React.StrictMode>
);

unregister(); // Unregister to prevent browser cache.
